/*
 * @Author: Chris 
 * @Date: 2022-07-27 16:06:34 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-31 11:29:01
 */
<template>
  <div class="LoginAccount" @keydown.stop="()=>{}">
    <div v-if="stage == 1">
      <div class="input">
        <div class="input_name">账号</div>
        <el-input
          v-model="Account"
          placeholder="请输入你的手机号/账号"
        ></el-input>
      </div>
      <div class="input">
        <div class="input_name">密码</div>
        <el-input
          v-model="Password"
          show-password
          placeholder="请输入你的密码"
        ></el-input>
      </div>
      <div class="input input_last" v-if="verificationCode">
        <div class="input_name">验证码</div>
        <el-input
          v-model="inputVerificationCode"
          placeholder="请输入验证码"
        ></el-input>
        <el-image
          class="codeImg"
          @click="getVerificationCode"
          :src="verificationCode"
        />
      </div>
      <div class="login_button" :class="{'has-code': verificationCode}">
        <div class="button" @click="nextType">下一步</div>
      </div>
    </div>

    <div v-if="stage == 2">
      <div class="choose_title">
        选择组织
        <div class="choose_title_line"></div>
      </div>
      <div class="choose_list">
        <div
          class="choose_list_in"
          :class="choosecomID == item.companyId ? 'choose_list_inin' : ''"
          v-for="item in conList"
          :key="item.companyId"
          @click="choosecompany(item)"
        >
          <img
            v-if="!item.companyLogo"
            src="../../../assets/IMG/organization/compny.png"
            class="img_first"
            alt=""
          />
          <el-image
            v-if="item.companyLogo"
            class="left_img"
            :src="item.companyLogo"
            alt=""
          />
          {{ item.companyName }}
          <span class="right-icon" v-if="item.type === 0">维保单位</span>
          <span class="right-icon" v-else-if="item.type === 1">使用单位</span>
          <span class="right-icon" v-else-if="item.type === 2">监管单位</span>
          <span class="right-icon" v-else-if="item.type === 3">保险单位</span>
        </div>
      </div>
      <div class="login_button">
        <div class="button_left" @click="gobackM">上一步</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLogin, loginByCode, authbasiccaptchaImage } from "../../../api/api";
export default {
  name: "LoginAccount",
  data() {
    return {
      stage: 1, //阶段
      Account: "", //账号
      Password: "", //密码
      uuid: "", //验证码的UUid
      inputVerificationCode: "", //输入的验证码
      verificationCode: "", //
      conList: [], //公司列表
      choosecomID: "",
    };
  },

  /**
   * 监听回车按键
   * */

  created() {
    // let this_ = this;
    // document.onkeydown = function (e) {
    //   var key = window.event.keyCode;
    //   if (key == 13) {
    //     this_.loginM();
    //   }
    // };
  },

  beforeDestroy() {
    document.onkeydown = null;
  },

  methods: {
    // 点击选择公司
    choosecompany(e) {
      this.choosecomID = e.companyId;
      this.loginM();
    },
    // 下一步
    async nextType() {
      let this_ = this;
      let params = {
        usernameOrPhone: this.Account,
        password: this.Password,
        sysCode: "user_management",
        uuid: this.uuid,
        graphicVerificationCode: this.inputVerificationCode,
      };
      if (this.Account && this.Password && this.Account != "admin") {
        this.$store.commit("SET_LoginstatusbyPhone", 2);
        let res = await getLogin(params);
        if (res.code == 6005) {
          this.$notify.error({
            title: "错误",
            message: "非管理员角色不能登录",
          });
          return;
        }
        // 获取图形验证码 6001 密码错误超过次数
        if (res.code == 6001) {
          this.setCode(res.data.graphicVerificationCode, res.data.uuid);
          return;
        }
        // 需要刷新图形验证码 7001 图形验证码过期
        if (res.code == 7001) {
          this.getVerificationCode();
          return;
        }
        if (res.code == 200) {
          this.stage = 2;
          this.conList = res.data;
          if (this.conList.length == 1) {
            this_.choosecomID = res.data[0].companyId;
            this_.loginM();
          }
        }
      } else if (this.Account == "admin") {
        let res = await getLogin(params);
        // 获取图形验证码 6001 密码错误超过次数
        if (res.code == 6001) {
          this.setCode(res.data.graphicVerificationCode, res.data.uuid);
          return;
        }
        // 需要刷新图形验证码 7001 图形验证码过期
        if (res.code == 7001) {
          this.getVerificationCode();
          return;
        }
        if (res.code == 200) {
          let res2 = await loginByCode({ code: res.data });
          if (res2.code == 200) {
            window.localStorage.setItem("UM_accessToken", res2.data);
            this.$notify.success({
              title: "成功",
              message: "登录成功，即将跳转到首页",
            });
            setTimeout(() => {
              this.$router.push("/userManagement");
            }, 1000);
          }
        }
      }
    },
    async loginM() {
      if (!this.Account || !this.Password) {
        this.$notify.error({
          title: "错误",
          message: "您输入的账号不存在或密码错误",
        });
        return;
      }
      let params = {
        usernameOrPhone: this.Account,
        password: this.Password,
        sysCode: "user_management",
        companyId: this.choosecomID,
        uuid: this.uuid,
        graphicVerificationCode: this.inputVerificationCode,
      };
      let res = await getLogin(params);
      // 获取图形验证码 6001 密码错误超过次数
      if (res.code == 6001) {
        this.setCode(res.data.graphicVerificationCode, res.data.uuid);
        return;
      }
      // 需要刷新图形验证码 7001 图形验证码过期
      if (res.code == 7001) {
        this.getVerificationCode();
        return;
      }
      if (res.code == 200) {
        let res2 = await loginByCode({ code: res.data });
        if (res2.code == 200) {
          window.localStorage.setItem("UM_accessToken", res2.data);
          this.$notify.success({
            title: "成功",
            message: "登录成功，即将跳转到首页",
          });
          setTimeout(() => {
            if (this.Account == "admin") {
              this.$router.push("/userManagement");
            } else {
              this.$router.push("/organization");
            }
          }, 1000);
        }
      }
    },
    // 返回上一步
    gobackM() {
      this.stage = 1;
      this.$store.commit("SET_LoginstatusbyPhone", 1);
      this.choosecomID = null;
    },
    // 获取图形验证码
    async getVerificationCode() {
      let res = await authbasiccaptchaImage();
      if (res.code === 200) {
        this.setCode(res.data.graphicVerificationCode, res.data.uuid);
      }
    },
    setCode(verificationCode, uuid) {
      this.verificationCode = "data:image/png;base64," + verificationCode;
      this.uuid = uuid;
    },
  },
};
</script>

<style lang="scss" scoped>
.LoginAccount {
  width: 100%;
  .input {
    position: relative;
    padding: 1.25rem 0 0.625rem 0;
    .input_name {
      z-index: 5;
      position: absolute;
      color: #999999;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.375rem;
      background: #fff;
      left: 5%;
      top: 0.375rem;
    }
  }

  .input_last {
    display: flex;
  }

  .erro {
    user-select: none;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.0625rem;
    color: #f84638;
  }

  .login_button {
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3.75rem;
    &.has-code {
      margin-top: 0.625rem;
    }

    .button {
      cursor: pointer;
      width: 4rem;
      height: 2rem;
      background: #b7282d;
      border-radius: 0.25rem;
      color: #ffffff;
      font-size: 0.75rem;
      line-height: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .button_left {
      cursor: pointer;
      width: 4rem;
      height: 2rem;
      background: #fff;
      border-radius: 0.25rem;
      color: #b7282d;
      border: 0.0625rem solid #b7282d;
      box-sizing: border-box;
      margin-right: 0.625rem;
      font-size: 0.75rem;
      line-height: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.choose_title {
  width: 100%;
  text-align: center;
  color: #b7282d;
  font-size: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .choose_title_line {
    width: 20%;
    height: 0.0625rem;
    border-bottom: 0.125rem solid #b7282d;
  }
}

.choose_list {
  margin-top: 20px;
  height: 164px;
  overflow-y: auto;

  .choose_list_in {
    box-sizing: border-box;
    border: 0.0625rem solid #ededed;
    user-select: none;
    cursor: pointer;
    width: 98%;
    height: 3rem;
    background: #ededed;
    border-radius: 0.25rem;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    .right-icon {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 4px 0 4px;
      font-size: 12px;
      padding: 0 6px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #b7282d;
      background: rgba(183, 40, 45, 0.09);
    }
    .left_img {
      margin: 0 0.5rem;
      width: 2rem;
      height: 2rem;
    }

    .img_first {
      margin: 0 0.5rem;
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 1.125rem;
      border-radius: 0.25rem;
    }
    :hover {
      border: none;
    }
  }
  :hover {
    box-sizing: border-box;
    border: 0.0625rem solid #b7282d;
  }

  .choose_list_inin {
    background: rgba(183, 40, 45, 0.06);
  }
}
</style>